"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    SwatchPicker: function() {
        return _index.SwatchPicker;
    },
    renderSwatchPicker_unstable: function() {
        return _index.renderSwatchPicker_unstable;
    },
    swatchPickerClassNames: function() {
        return _index.swatchPickerClassNames;
    },
    useSwatchPickerStyles_unstable: function() {
        return _index.useSwatchPickerStyles_unstable;
    },
    useSwatchPicker_unstable: function() {
        return _index.useSwatchPicker_unstable;
    }
});
const _index = require("./components/SwatchPicker/index");
